import { MdOutlineThumbUpOffAlt } from "react-icons/md";
import "./StickyLike.scss";
// import { Link } from "react-router-dom";
// import { useState } from "react";

const StickyLike = ({
  isLoggedIn,
  navigate,
  dispatch,
  addLike,
  removeLike,
  id,
}) => {
  // const [likee, setLikee] = useState(false);
  // const [removeLikee, setRemoveLikee] = useState(false);

  return (
    <div
      className="like"
      onClick={() => (!isLoggedIn ? navigate("/login") : dispatch(addLike(id)))}
    >
      <span className="icon">
        <MdOutlineThumbUpOffAlt color="#ff9f31" size={40} />
      </span>
    </div>
  );
};
export default StickyLike;
